import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'tngh-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {

}
